var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 32,
    viewBox: "0 0 14 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 31C12 31.5523 12.4477 32 13 32C13.5523 32 14 31.5523 14 31H13H12ZM13 0H12V31H13H14V0H13Z",
    fill: "#37A2B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5L5.41 12.91L3.83 14.5H12V16.5H3.83L5.41 18.08L4 19.5L0 15.5L4 11.5Z",
    fill: "#37A2B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.6531027d227717a2160e4debe401e2fc.svg";
export { ForwardRef as ReactComponent };